import { apiSlice } from "../../app/apiSlice"

export const giftCardApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getGiftCard: build.mutation({
      query: (body) => ({
        url: "/gift-cards/public?include=status,giftCardLogs,giftCardLogs.filial",
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useGetGiftCardMutation,
} = giftCardApiSlice
